export default __webpack_public_path__ + "static/media/alien.5492e5cd.gif";